import { Box, Button, Typography } from "@mui/material";
import { Link } from "@mui/material";
import { Sms } from "@mui/icons-material";
import StoreSlide from "./storeSlide";
import { HashLink } from 'react-router-hash-link';

const StoreMap = ({ store, branch, name, address = "", contact, map }) => {
  return (
    <Box display='block' sx={{ textAlign: 'center', px: '2em' }}>
      <HashLink to={`/staff#${branch}`} >
        <Typography variant="h2" sx={{ py: '1em', fontWeight: '800', textDecoration: 'underline' }}>{name}</Typography>
      </HashLink>
      <StoreSlide store={store} branch={branch} />
      <Typography variant="h4" sx={{ lineHeight: '1.5em', py: '1em', textAlign: 'center' }}>
        <Link href={`tel:${contact}`} color='inherit' underline="none" target='_blank'
          sx={{ display: 'flex', alignItems: 'left', justifyContent: 'center', pb: '1em' }}>
          <Sms /><Typography variant="h4">&nbsp;{contact}</Typography>
        </Link>
        <Link href={`https://maps.google.com/?q=${address}`} color='inherit' underline="none" target='_blank'>
          {address.split(',')[0]}<br />
          {address.split(',')[1]}<br />
        </Link>
      </Typography>

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', pb: '2em' }}>
        <Typography variant="h3" sx={{
          width: '50%',
          fontWeight: '800',
          backgroundColor: 'black',
          color: 'white',
          borderRadius: '10px',
          textDecoration: 'none',
          p: '1em',
          '&:hover': {
            backgroundColor: 'black',
            color: 'white',
          },
          '&:active': {
            backgroundColor: 'black',
            color: 'white',
          },
          '&:focus': {
            backgroundColor: 'black',
            color: 'white',
          },
        }}>
          <HashLink to={`/staff#${branch}`} >
            Find more...
          </HashLink>
        </Typography>

      </Box>
      {/* <Box sx={{ width: '100%', overflow: 'hidden', pb: '2em' }}>
        <iframe
          src={map}
          width="100%"
          height="200"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          sandbox="allow-forms allow-scripts"
        ></iframe>
      </Box> */}
    </Box>
  );
};

export default StoreMap;